import { useTheme } from '@approvalmax/theme';
import { useMedia } from 'react-use';

export const useReportsListColumns = (): 3 | 2 => {
    const { theme } = useTheme();
    const isMediumScreen = useMedia(`(max-width: ${theme.container.breakpoint.medium})`);

    return isMediumScreen ? 2 : 3;
};
